import { infoReport } from '@/utils/report';

export class HeadlessDetector {
  private static isLogged = false;

  static isHeadlessUser(userAgent: string) {
    return /headless|phantomjs|bot|crawl/.test(userAgent);
  }

  private static isHeadlessUserAgent(navigator: Navigator) {
    const userAgent = navigator.userAgent.toLowerCase();
    return /headless|phantomjs|bot|crawl/.test(userAgent);
  }

  private static isWebdriverPresent(navigator: Navigator) {
    return !!navigator.webdriver;
  }

  private static hasInvalidLanguages(navigator: Navigator) {
    const language = navigator.language;
    const languagesLength = navigator.languages.length;
    return !language || languagesLength === 0;
  }

  /* 창 크기 0이면 헤드리스로 판단해도 되는지 여부를 로깅 후 추가할 계획 */
  private static hasZeroDimensions(window: Window) {
    const outerWidth = window.outerWidth;
    const outerHeight = window.outerHeight;
    const innerWidth = window.innerWidth;
    const innerHeight = window.innerHeight;
    return outerWidth === 0 && outerHeight === 0 && innerWidth === 0 && innerHeight === 0;
  }

  static shouldInitializeSDK(window: Window) {
    if (!window.navigator) {
      return false;
    }

    if (this.hasZeroDimensions(window) && !this.isLogged) {
      this.isLogged = true;

      infoReport('HeadlessDetector에서 창 크기 0 감지 > 헤드리스가 아닌지 확인 필요', {
        userAgent: window.navigator.userAgent,
      });
    }

    if (this.isHeadlessUserAgent(window.navigator)) {
      return false;
    }
    if (this.isWebdriverPresent(window.navigator)) {
      return false;
    }
    if (this.hasInvalidLanguages(window.navigator)) {
      return false;
    }

    return true;
  }
}
